import { action } from 'typesafe-actions';
import { buildTransactionPayload } from '../transaction/utils';
// Fetch authorizations
export const FETCH_AUTHORIZATIONS_REQUEST = '[Request] Fetch Authorizations';
export const FETCH_AUTHORIZATIONS_SUCCESS = '[Success] Fetch Authorizations';
export const FETCH_AUTHORIZATIONS_FAILURE = '[Failure] Fetch Authorizations';
export const fetchAuthorizationsRequest = (authorizations) => action(FETCH_AUTHORIZATIONS_REQUEST, { authorizations });
/**
 * @param authorizations Tuple of the original authorization used to fetch and the authorization fetched result.
 * Necessary by the reducer to be able to remove authorizations fetched that now are not authorized anymore.
 */
export const fetchAuthorizationsSuccess = (authorizations) => action(FETCH_AUTHORIZATIONS_SUCCESS, { authorizations });
export const fetchAuthorizationsFailure = (authorizations, error) => action(FETCH_AUTHORIZATIONS_FAILURE, { authorizations, error });
// Grant Token
export const GRANT_TOKEN_REQUEST = '[Request] Grant Token';
export const GRANT_TOKEN_SUCCESS = '[Success] Grant Token';
export const GRANT_TOKEN_FAILURE = '[Failure] Grant Token';
export const grantTokenRequest = (authorization) => action(GRANT_TOKEN_REQUEST, {
    authorization
});
export const grantTokenSuccess = (authorization, chainId, txHash) => action(GRANT_TOKEN_SUCCESS, {
    ...buildTransactionPayload(chainId, txHash, {
        authorization
    }),
    authorization
});
export const grantTokenFailure = (authorization, error) => action(GRANT_TOKEN_FAILURE, { authorization, error });
// Revoke Token
export const REVOKE_TOKEN_REQUEST = '[Request] Revoke Token';
export const REVOKE_TOKEN_SUCCESS = '[Success] Revoke Token';
export const REVOKE_TOKEN_FAILURE = '[Failure] Revoke Token';
export const revokeTokenRequest = (authorization) => action(REVOKE_TOKEN_REQUEST, {
    authorization
});
export const revokeTokenSuccess = (authorization, chainId, txHash) => action(REVOKE_TOKEN_SUCCESS, {
    ...buildTransactionPayload(chainId, txHash, {
        authorization
    }),
    authorization
});
export const revokeTokenFailure = (authorization, error) => action(REVOKE_TOKEN_FAILURE, { authorization, error });
// Authorization Flow
export const AUTHORIZATION_FLOW_REQUEST = '[Request] Authorization Flow';
export const AUTHORIZATION_FLOW_SUCCESS = '[Success] Authorization Flow';
export const AUTHORIZATION_FLOW_FAILURE = '[Failure] Authorization Flow';
export const AUTHORIZATION_FLOW_CLEAR = '[Clear] Authorization Flow';
export const authorizationFlowRequest = (authorization, authorizationAction, allowance, traceId) => action(AUTHORIZATION_FLOW_REQUEST, {
    authorization,
    authorizationAction,
    allowance,
    traceId
});
export const authorizationFlowSuccess = (authorization) => action(AUTHORIZATION_FLOW_SUCCESS, {
    authorization
});
export const authorizationFlowFailure = (authorization, error) => action(AUTHORIZATION_FLOW_FAILURE, { authorization, error });
export const authorizationFlowClear = () => action(AUTHORIZATION_FLOW_CLEAR);
//# sourceMappingURL=actions.js.map